import { render, staticRenderFns } from "./CbsFormDynamic.vue?vue&type=template&id=a512313e&scoped=true"
import script from "./CbsFormDynamic.vue?vue&type=script&lang=js"
export * from "./CbsFormDynamic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a512313e",
  null
  
)

export default component.exports